/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface UpdateLootBoxPrizeResponse
 */
export interface UpdateLootBoxPrizeResponse {
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof UpdateLootBoxPrizeResponse
     */
    lootBoxConfig: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the UpdateLootBoxPrizeResponse interface.
 */
export function instanceOfUpdateLootBoxPrizeResponse(value: object): value is UpdateLootBoxPrizeResponse {
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    return true;
}

export function UpdateLootBoxPrizeResponseFromJSON(json: any): UpdateLootBoxPrizeResponse {
    return UpdateLootBoxPrizeResponseFromJSONTyped(json, false);
}

export function UpdateLootBoxPrizeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLootBoxPrizeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfig': LootBoxConfigResponseFromJSON(json['lootBoxConfig']),
    };
}

export function UpdateLootBoxPrizeResponseToJSON(json: any): UpdateLootBoxPrizeResponse {
    return UpdateLootBoxPrizeResponseToJSONTyped(json, false);
}

export function UpdateLootBoxPrizeResponseToJSONTyped(value?: UpdateLootBoxPrizeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfig': LootBoxConfigResponseToJSON(value['lootBoxConfig']),
    };
}

